
import SignInCover from "./login";

export default function SignInCoverPage() {
  return <SignInCover />;
}
